import "@/App.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { ServiceMarquee } from "@/components/site/ServiceMarquee";
import { TrustedBy } from "@/components/site/TrustedBy";
import { ProofGallery } from "@/components/site/ProofGallery";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Guarantee } from "@/components/site/Guarantee";
import { ContactFooter } from "@/components/site/ContactFooter";

function App() {
  return (
    <SmoothScroll>
      <div className="App bg-paper" data-testid="app-root">
        <Nav />
        <main>
          <Hero />
          <ServiceMarquee />
          <TrustedBy />
          <ProofGallery />
          <Services />
          <Manifesto />
          <Guarantee />
        </main>
        <ContactFooter />
      </div>
    </SmoothScroll>
  );
}

export default App;
